import { createRouter, createWebHistory } from 'vue-router'
import { ElMessage } from 'element-plus'

import { useUserStore } from '@/stores/user'
import { setDefaultWechatShare } from '@/utils/wechatShare'
import routes from './routes'

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 浏览器前进/后退恢复滚动位置
    if (savedPosition) return savedPosition
    // 仅 query / hash 变化（同一个 path）不滚动，避免"筛选/翻页"等操作把用户顶回顶部
    if (to.path === from.path) return false
    // 真路由切换才回顶
    return { top: 0 }
  },
})

router.beforeEach((to, _from, next) => {
  const userStore = useUserStore()

  // 设置页面标题
  const title = to.meta.title as string | undefined
  document.title = title ? `${title} - 百果量化` : '百果量化 - 专业量化交易社区'

  const requiresAuth = to.meta.requiresAuth as boolean | undefined

  if (requiresAuth && !userStore.isLoggedIn) {
    ElMessage.warning('请先登录')
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }

  // 已登录用户访问登录/注册页 → 跳首页
  if ((to.name === 'login' || to.name === 'register') && userStore.isLoggedIn) {
    next({ path: '/' })
    return
  }

  next()
})

// 微信分享卡片：非文章页用站点默认卡片；文章页由 TopicDetailView 拿到详情后自己设置。
// 不在微信里时 setDefaultWechatShare 直接返回，零开销。
router.afterEach((to) => {
  // 这几页自己设置分享卡片（标题 / 摘要），这里跳过，避免默认卡片和页面设置互相覆盖
  const selfShare = [
    'topic-detail',
    'wechat-login',
    'academy',
    'ptrade',
    'ptrade-intro',
    'ptrade-strategy',
    'ptrade-live',
  ]
  if (!selfShare.includes(String(to.name))) {
    void setDefaultWechatShare()
  }
})

export default router
